const CountryStateData = {
  Afghanistan: [
    "Badakhshan",
    "Badghis",
    "Baghlan",
    "Balkh",
    "Bamyan",
    "Daykundi",
    "Farah",
    "Faryab",
    "Ghazni",
    "Ghor",
    "Helmand",
    "Herat",
    "Jowzjan",
    "Kabul",
    "Kandahar",
    "Khost",
    "Kunar",
    "Kunduz",
    "Laghman",
    "Logar",
    "Nangarhar",
    "Nimroz",
    "Paktika",
    "Paktiya",
    "Panjshayr",
    "Parwan",
    "Samangan",
    "Sar-e Pul",
    "Takhar",
    "Uruzgan",
  ],
  Albania: [
    "Berat",
    "Diber",
    "Durres",
    "Elbasan",
    "Fier",
    "Gjirokaster",
    "Korce",
    "Kukes",
    "Lezhe",
    "Shkoder",
    "Tirane",
    "Vlore",
  ],
  Algeria: [
    "Adrar",
    "Ain Defla",
    "Ain Temouchent",
    "Alger",
    "Annaba",
    "Batna",
    "Bechar",
    "Bejaia",
    "Biskra",
    "Blida",
    "Bordj Bou Arreridj",
    "Bouira",
    "Boumerdes",
    "Chlef",
    "Constantine",
    "Djanet",
    "Djelfa",
    "El Bayadh",
    "El Meghaier",
    "El Oued",
    "El Tarf",
    "Ghardaia",
    "Guelma",
    "Illizi",
    "In Salah",
    "Jijel",
    "Khenchela",
    "Laghouat",
    "M'sila",
    "Mascara",
    "Medea",
    "Mila",
    "Mostaganem",
    "Naama",
    "Oran",
    "Ouargla",
    "Ouled Djellal",
    "Oum el Bouaghi",
    "Relizane",
    "Saida",
    "Setif",
    "Sidi Bel Abbes",
    "Skikda",
    "Souk Ahras",
    "Tamanrasset",
    "Tebessa",
    "Tiaret",
    "Timimoun",
    "Tindouf",
    "Tipaza",
    "Tissemsilt",
    "Tizi Ouzou",
    "Tlemcen",
    "Touggourt",
  ],
  "American Samoa": ["Eastern District", "Western District"],
  Andorra: [
    "Andorra la Vella",
    "Canillo",
    "Encamp",
    "Escaldes-Engordany",
    "La Massana",
    "Ordino",
    "Sant Julia de Loria",
  ],
  Angola: [
    "Bengo",
    "Benguela",
    "Bie",
    "Cabinda",
    "Cuando Cubango",
    "Cuanza-Norte",
    "Cuanza-Sul",
    "Cunene",
    "Huambo",
    "Huila",
    "Luanda",
    "Lunda-Norte",
    "Lunda-Sul",
    "Malange",
    "Moxico",
    "Namibe",
    "Uige",
    "Zaire",
  ],
  Anguilla: ["Anguilla"],
  Antarctica: ["Antarctica"],
  "Antigua and Barbuda": [
    "Barbuda",
    "Saint George",
    "Saint John",
    "Saint Mary",
    "Saint Paul",
    "Saint Peter",
    "Saint Philip",
  ],
  Argentina: [
    "Buenos Aires",
    "Catamarca",
    "Chaco",
    "Chubut",
    "Ciudad Autonoma de Buenos Aires",
    "Cordoba",
    "Corrientes",
    "Entre Rios",
    "Formosa",
    "Jujuy",
    "La Pampa",
    "La Rioja",
    "Mendoza",
    "Misiones",
    "Neuquen",
    "Rio Negro",
    "Salta",
    "San Juan",
    "San Luis",
    "Santa Cruz",
    "Santa Fe",
    "Santiago del Estero",
    "Tierra del Fuego",
    "Tucuman",
  ],
  Armenia: [
    "Aragacotn",
    "Ararat",
    "Armavir",
    "Erevan",
    "Gegark'unik'",
    "Kotayk'",
    "Lori",
    "Sirak",
    "Syunik'",
    "Tavus",
    "Vayoc Jor",
  ],
  Aruba: ["Aruba"],
  Australia: [
    "Australian Capital Territory",
    "New South Wales",
    "Northern Territory",
    "Queensland",
    "South Australia",
    "Tasmania",
    "Victoria",
    "Western Australia",
  ],
  Austria: [
    "Burgenland",
    "Karnten",
    "Niederosterreich",
    "Oberosterreich",
    "Salzburg",
    "Steiermark",
    "Tirol",
    "Vorarlberg",
    "Wien",
  ],
  Azerbaijan: [
    "Abseron",
    "Agcabadi",
    "Agdas",
    "Agstafa",
    "Agsu",
    "Astara",
    "Baki",
    "Balakan",
    "Barda",
    "Beylaqan",
    "Cabrayil",
    "Calilabad",
    "Gadabay",
    "Ganca",
    "Goranboy",
    "Goycay",
    "Goygol",
    "Haciqabul",
    "Imisli",
    "Ismayilli",
    "Kalbacar",
    "Kurdamir",
    "Lankaran",
    "Masalli",
    "Mingacevir",
    "Naxcivan",
    "Neftcala",
    "Oguz",
    "Qabala",
    "Qazax",
    "Quba",
    "Qusar",
    "Saatli",
    "Sabirabad",
    "Saki",
    "Salyan",
    "Samaxi",
    "Samkir",
    "Samux",
    "Sirvan",
    "Siyazan",
    "Sumqayit",
    "Tartar",
    "Tovuz",
    "Ucar",
    "Xacmaz",
    "Xizi",
    "Yardimli",
    "Yevlax",
    "Zaqatala",
    "Zardab",
  ],
  Bahamas: [
    "Black Point",
    "Central Abaco",
    "City of Freeport",
    "East Grand Bahama",
    "Harbour Island",
    "Long Island",
    "Moore's Island",
    "New Providence",
    "North Andros",
    "North Eleuthera",
    "San Salvador",
    "South Eleuthera",
    "West Grand Bahama",
  ],
  Bahrain: ["Al 'Asimah", "Al Janubiyah", "Al Muharraq", "Ash Shamaliyah"],
  Bangladesh: [
    "Barishal",
    "Chattogram",
    "Dhaka",
    "Khulna",
    "Rajshahi",
    "Rangpur",
    "Sylhet",
  ],
  Barbados: [
    "Christ Church",
    "Saint Andrew",
    "Saint George",
    "Saint James",
    "Saint John",
    "Saint Joseph",
    "Saint Lucy",
    "Saint Michael",
    "Saint Peter",
    "Saint Philip",
    "Saint Thomas",
  ],
  Belarus: [
    "Brestskaya voblasts'",
    "Homyel'skaya voblasts'",
    "Horad Minsk",
    "Hrodzyenskaya voblasts'",
    "Mahilyowskaya voblasts'",
    "Minskaya voblasts'",
    "Vitsyebskaya voblasts'",
  ],
  Belgium: [
    "Antwerpen",
    "Brabant wallon",
    "Brussels Hoofdstedelijk Gewest",
    "Hainaut",
    "Liege",
    "Limburg",
    "Luxembourg",
    "Namur",
    "Oost-Vlaanderen",
    "Vlaams-Brabant",
    "West-Vlaanderen",
  ],
  Belize: ["Belize", "Cayo", "Corozal", "Orange Walk", "Stann Creek", "Toledo"],
  Benin: [
    "Atacora",
    "Atlantique",
    "Borgou",
    "Collines",
    "Donga",
    "Littoral",
    "Oueme",
    "Plateau",
    "Zou",
  ],
  Bermuda: ["Hamilton", "Saint George"],
  Bhutan: [
    "Bumthang",
    "Chhukha",
    "Dagana",
    "Gasa",
    "Lhuentse",
    "Monggar",
    "Paro",
    "Pema Gatshel",
    "Punakha",
    "Samdrup Jongkhar",
    "Samtse",
    "Sarpang",
    "Thimphu",
    "Trashigang",
    "Trongsa",
    "Tsirang",
    "Wangdue Phodrang",
  ],
  Bolivia: [
    "Chuquisaca",
    "Cochabamba",
    "El Beni",
    "La Paz",
    "Oruro",
    "Pando",
    "Potosi",
    "Santa Cruz",
    "Tarija",
  ],
  "Bonaire, Sint Eustatius and Saba": ["Bonaire", "Saba", "Sint Eustatius"],
  "Bosnia and Herzegovina": [
    "Brcko distrikt",
    "Federacija Bosne i Hercegovine",
    "Republika Srpska",
  ],
  Botswana: [
    "Central",
    "Chobe",
    "Ghanzi",
    "Kgatleng",
    "Kweneng",
    "North East",
    "North West",
    "South East",
    "Southern",
  ],
  "Bouvet Island": ["Bouvet Island"],
  Brazil: [
    "Acre",
    "Alagoas",
    "Amapa",
    "Amazonas",
    "Bahia",
    "Ceara",
    "Distrito Federal",
    "Espirito Santo",
    "Goias",
    "Maranhao",
    "Mato Grosso",
    "Mato Grosso do Sul",
    "Minas Gerais",
    "Para",
    "Paraiba",
    "Parana",
    "Pernambuco",
    "Piaui",
    "Rio Grande do Norte",
    "Rio Grande do Sul",
    "Rio de Janeiro",
    "Rondonia",
    "Roraima",
    "Santa Catarina",
    "Sao Paulo",
    "Sergipe",
    "Tocantins",
  ],
  "British Indian Ocean Territory": ["British Indian Ocean Territory"],
  "Brunei Darussalam": ["Belait", "Brunei-Muara", "Temburong", "Tutong"],
  Bulgaria: [
    "Blagoevgrad",
    "Burgas",
    "Dobrich",
    "Gabrovo",
    "Haskovo",
    "Kardzhali",
    "Kyustendil",
    "Lovech",
    "Montana",
    "Pazardzhik",
    "Pernik",
    "Pleven",
    "Plovdiv",
    "Razgrad",
    "Ruse",
    "Shumen",
    "Silistra",
    "Sliven",
    "Smolyan",
    "Sofia",
    "Sofia (stolitsa)",
    "Stara Zagora",
    "Targovishte",
    "Varna",
    "Veliko Tarnovo",
    "Vidin",
    "Vratsa",
    "Yambol",
  ],
  "Burkina Faso": [
    "Bale",
    "Bam",
    "Banwa",
    "Bazega",
    "Boulgou",
    "Boulkiemde",
    "Comoe",
    "Ganzourgou",
    "Gnagna",
    "Gourma",
    "Houet",
    "Kadiogo",
    "Kenedougou",
    "Kompienga",
    "Kossi",
    "Kouritenga",
    "Kourweogo",
    "Leraba",
    "Loroum",
    "Mouhoun",
    "Nahouri",
    "Namentenga",
    "Nayala",
    "Oubritenga",
    "Oudalan",
    "Passore",
    "Sanmatenga",
    "Seno",
    "Sissili",
    "Soum",
    "Tapoa",
    "Tuy",
    "Yatenga",
    "Ziro",
    "Zondoma",
    "Zoundweogo",
  ],
  Burundi: [
    "Bujumbura Mairie",
    "Bururi",
    "Cibitoke",
    "Gitega",
    "Karuzi",
    "Kayanza",
    "Kirundo",
    "Makamba",
    "Mwaro",
    "Ngozi",
    "Rumonge",
    "Rutana",
    "Ruyigi",
  ],
  Cambodia: [
    "Baat Dambang",
    "Banteay Mean Choay",
    "Kaeb",
    "Kampong Chaam",
    "Kampong Chhnang",
    "Kampong Spueu",
    "Kampong Thum",
    "Kampot",
    "Kandaal",
    "Kaoh Kong",
    "Kracheh",
    "Mondol Kiri",
    "Otdar Mean Chey",
    "Pailin",
    "Phnom Penh",
    "Pousaat",
    "Preah Sihanouk",
    "Preah Vihear",
    "Prey Veaeng",
    "Rotanak Kiri",
    "Siem Reab",
    "Stueng Traeng",
    "Svaay Rieng",
    "Taakaev",
  ],
  Cameroon: [
    "Adamaoua",
    "Centre",
    "Est",
    "Extreme-Nord",
    "Littoral",
    "Nord",
    "Nord-Ouest",
    "Ouest",
    "Sud",
    "Sud-Ouest",
  ],
  Canada: [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Northwest Territories",
    "Nova Scotia",
    "Nunavut",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
    "Yukon",
  ],
  "Cape Verde": [
    "Boa Vista",
    "Maio",
    "Paul",
    "Porto Novo",
    "Praia",
    "Ribeira Grande",
    "Ribeira Grande de Santiago",
    "Sal",
    "Santa Cruz",
    "Sao Filipe",
    "Sao Lourenco dos Orgaos",
    "Sao Miguel",
    "Sao Vicente",
    "Tarrafal",
  ],
  "Cayman Islands": ["Cayman Islands"],
  "Central African Republic": [
    "Bamingui-Bangoran",
    "Bangui",
    "Gribingui",
    "Haut-Mbomou",
    "Haute-Kotto",
    "Kemo-Gribingui",
    "Lobaye",
    "Mambere-Kadei",
    "Nana-Mambere",
    "Ouaka",
    "Ouham",
    "Ouham-Pende",
    "Vakaga",
  ],
  Chad: [
    "Bahr el Ghazal",
    "Borkou",
    "Chari-Baguirmi",
    "Guera",
    "Lac",
    "Logone-Occidental",
    "Mayo-Kebbi-Est",
    "Ouaddai",
    "Ville de Ndjamena",
    "Wadi Fira",
  ],
  Chile: [
    "Aisen del General Carlos Ibanez del Campo",
    "Antofagasta",
    "Arica y Parinacota",
    "Atacama",
    "Biobio",
    "Coquimbo",
    "La Araucania",
    "Libertador General Bernardo O'Higgins",
    "Los Lagos",
    "Los Rios",
    "Magallanes",
    "Maule",
    "Nuble",
    "Region Metropolitana de Santiago",
    "Tarapaca",
    "Valparaiso",
  ],
  China: [
    "Anhui",
    "Beijing",
    "Chongqing",
    "Fujian",
    "Gansu",
    "Guangdong",
    "Guangxi Zhuangzu",
    "Guizhou",
    "Hainan",
    "Hebei",
    "Heilongjiang",
    "Henan",
    "Hubei",
    "Hunan",
    "Jiangsu",
    "Jiangxi",
    "Jilin",
    "Liaoning",
    "Nei Mongol",
    "Ningxia Huizu",
    "Qinghai",
    "Shaanxi",
    "Shandong",
    "Shanghai",
    "Shanxi",
    "Sichuan",
    "Tianjin",
    "Xinjiang Uygur",
    "Xizang",
    "Yunnan",
    "Zhejiang",
  ],
  "Christmas Island": ["Christmas Island"],
  "Cocos (Keeling) Islands": ["Cocos (Keeling) Islands"],
  Colombia: [
    "Amazonas",
    "Antioquia",
    "Arauca",
    "Atlantico",
    "Bolivar",
    "Boyaca",
    "Caldas",
    "Caqueta",
    "Casanare",
    "Cauca",
    "Cesar",
    "Choco",
    "Cordoba",
    "Cundinamarca",
    "Distrito Capital de Bogota",
    "Guainia",
    "Guaviare",
    "Huila",
    "La Guajira",
    "Magdalena",
    "Meta",
    "Narino",
    "Norte de Santander",
    "Putumayo",
    "Quindio",
    "Risaralda",
    "San Andres, Providencia y Santa Catalina",
    "Santander",
    "Sucre",
    "Tolima",
    "Valle del Cauca",
    "Vaupes",
    "Vichada",
  ],
  Comoros: ["Grande Comore", "Moheli"],
  Congo: [
    "Bouenza",
    "Brazzaville",
    "Cuvette",
    "Likouala",
    "Niari",
    "Pointe-Noire",
    "Sangha",
  ],
  "Cook Islands": ["Cook Islands"],
  "Costa Rica": [
    "Alajuela",
    "Cartago",
    "Guanacaste",
    "Heredia",
    "Limon",
    "Puntarenas",
    "San Jose",
  ],
  Croatia: [
    "Bjelovarsko-bilogorska zupanija",
    "Brodsko-posavska zupanija",
    "Dubrovacko-neretvanska zupanija",
    "Grad Zagreb",
    "Istarska zupanija",
    "Karlovacka zupanija",
    "Koprivnicko-krizevacka zupanija",
    "Krapinsko-zagorska zupanija",
    "Licko-senjska zupanija",
    "Medimurska zupanija",
    "Osjecko-baranjska zupanija",
    "Pozesko-slavonska zupanija",
    "Primorsko-goranska zupanija",
    "Sibensko-kninska zupanija",
    "Sisacko-moslavacka zupanija",
    "Splitsko-dalmatinska zupanija",
    "Varazdinska zupanija",
    "Viroviticko-podravska zupanija",
    "Vukovarsko-srijemska zupanija",
    "Zadarska zupanija",
    "Zagrebacka zupanija",
  ],
  Cuba: [
    "Artemisa",
    "Camaguey",
    "Ciego de Avila",
    "Cienfuegos",
    "Granma",
    "Guantanamo",
    "Holguin",
    "Isla de la Juventud",
    "La Habana",
    "Las Tunas",
    "Matanzas",
    "Mayabeque",
    "Pinar del Rio",
    "Sancti Spiritus",
    "Santiago de Cuba",
    "Villa Clara",
  ],
  Curaçao: ["Curacao"],
  Cyprus: [
    "Ammochostos",
    "Keryneia",
    "Larnaka",
    "Lefkosia",
    "Lemesos",
    "Pafos",
  ],
  "Czech Republic": [
    "Jihocesky kraj",
    "Jihomoravsky kraj",
    "Karlovarsky kraj",
    "Kraj Vysocina",
    "Kralovehradecky kraj",
    "Liberecky kraj",
    "Moravskoslezsky kraj",
    "Olomoucky kraj",
    "Pardubicky kraj",
    "Plzensky kraj",
    "Praha, Hlavni mesto",
    "Stredocesky kraj",
    "Ustecky kraj",
    "Zlinsky kraj",
  ],
  "Côte d'Ivoire": [
    "Abidjan",
    "Bas-Sassandra",
    "Comoe",
    "Denguele",
    "Goh-Djiboua",
    "Lacs",
    "Lagunes",
    "Montagnes",
    "Sassandra-Marahoue",
    "Savanes",
    "Vallee du Bandama",
    "Woroba",
    "Yamoussoukro",
    "Zanzan",
  ],
  "Democratic Republic of the Congo": [
    "Equateur",
    "Haut-Katanga",
    "Haut-Lomami",
    "Ituri",
    "Kasai",
    "Kasai Central",
    "Kasai Oriental",
    "Kinshasa",
    "Kongo Central",
    "Kwilu",
    "Lualaba",
    "Maniema",
    "Nord-Kivu",
    "Sankuru",
    "Sud-Kivu",
    "Tanganyika",
    "Tshopo",
    "Tshuapa",
  ],
  Denmark: [
    "Hovedstaden",
    "Midtjylland",
    "Nordjylland",
    "Sjaelland",
    "Syddanmark",
  ],
  Djibouti: ["Arta", "Dikhil", "Djibouti", "Tadjourah"],
  Dominica: [
    "Saint Andrew",
    "Saint George",
    "Saint John",
    "Saint Joseph",
    "Saint Luke",
    "Saint Patrick",
    "Saint Paul",
  ],
  "Dominican Republic": [
    "Azua",
    "Baoruco",
    "Barahona",
    "Dajabon",
    "Distrito Nacional (Santo Domingo)",
    "Duarte",
    "El Seibo",
    "Elias Pina",
    "Espaillat",
    "Hato Mayor",
    "Hermanas Mirabal",
    "Independencia",
    "La Altagracia",
    "La Romana",
    "La Vega",
    "Maria Trinidad Sanchez",
    "Monsenor Nouel",
    "Monte Cristi",
    "Monte Plata",
    "Pedernales",
    "Peravia",
    "Puerto Plata",
    "Samana",
    "San Cristobal",
    "San Jose de Ocoa",
    "San Juan",
    "San Pedro de Macoris",
    "Sanchez Ramirez",
    "Santiago",
    "Santiago Rodriguez",
    "Valverde",
  ],
  Ecuador: [
    "Azuay",
    "Bolivar",
    "Canar",
    "Carchi",
    "Chimborazo",
    "Cotopaxi",
    "El Oro",
    "Esmeraldas",
    "Galapagos",
    "Guayas",
    "Imbabura",
    "Loja",
    "Los Rios",
    "Manabi",
    "Morona Santiago",
    "Napo",
    "Orellana",
    "Pastaza",
    "Pichincha",
    "Santa Elena",
    "Santo Domingo de los Tsachilas",
    "Sucumbios",
    "Tungurahua",
    "Zamora Chinchipe",
  ],
  Egypt: [
    "Ad Daqahliyah",
    "Al Bahr al Ahmar",
    "Al Buhayrah",
    "Al Fayyum",
    "Al Gharbiyah",
    "Al Iskandariyah",
    "Al Isma'iliyah",
    "Al Jizah",
    "Al Minufiyah",
    "Al Minya",
    "Al Qahirah",
    "Al Qalyubiyah",
    "Al Uqsur",
    "Al Wadi al Jadid",
    "As Suways",
    "Ash Sharqiyah",
    "Aswan",
    "Asyut",
    "Bani Suwayf",
    "Bur Sa'id",
    "Dumyat",
    "Janub Sina'",
    "Kafr ash Shaykh",
    "Matruh",
    "Qina",
    "Shamal Sina'",
    "Suhaj",
  ],
  "El Salvador": [
    "Ahuachapan",
    "Cabanas",
    "Chalatenango",
    "Cuscatlan",
    "La Libertad",
    "La Paz",
    "La Union",
    "Morazan",
    "San Miguel",
    "San Salvador",
    "San Vicente",
    "Santa Ana",
    "Sonsonate",
    "Usulutan",
  ],
  "Equatorial Guinea": [
    "Bioko Norte",
    "Bioko Sur",
    "Centro Sur",
    "Kie-Ntem",
    "Litoral",
    "Wele-Nzas",
  ],
  Eritrea: ["Al Awsat", "Qash-Barkah"],
  Estonia: [
    "Harjumaa",
    "Hiiumaa",
    "Ida-Virumaa",
    "Jarvamaa",
    "Jogevamaa",
    "Laane-Virumaa",
    "Laanemaa",
    "Parnumaa",
    "Polvamaa",
    "Raplamaa",
    "Saaremaa",
    "Tartumaa",
    "Valgamaa",
    "Viljandimaa",
    "Vorumaa",
  ],
  Ethiopia: [
    "Addis Ababa",
    "Afar",
    "Amara",
    "Benshangul-Gumaz",
    "Dire Dawa",
    "Harari People",
    "Oromia",
    "Somali",
    "Southern Nations, Nationalities and Peoples",
    "Tigrai",
  ],
  "Falkland Islands": ["Falkland Islands (Malvinas)"],
  "Faroe Islands": [
    "Eysturoy",
    "Nordoyar",
    "Sandoy",
    "Streymoy",
    "Suduroy",
    "Vagar",
  ],
  Fiji: ["Central", "Eastern", "Northern", "Rotuma", "Western"],
  Finland: [
    "Etela-Karjala",
    "Etela-Pohjanmaa",
    "Etela-Savo",
    "Kainuu",
    "Kanta-Hame",
    "Keski-Pohjanmaa",
    "Keski-Suomi",
    "Kymenlaakso",
    "Lappi",
    "Paijat-Hame",
    "Pirkanmaa",
    "Pohjanmaa",
    "Pohjois-Karjala",
    "Pohjois-Pohjanmaa",
    "Pohjois-Savo",
    "Satakunta",
    "Uusimaa",
    "Varsinais-Suomi",
  ],
  France: [
    "Auvergne-Rhone-Alpes",
    "Bourgogne-Franche-Comte",
    "Bretagne",
    "Centre-Val de Loire",
    "Corse",
    "Grand-Est",
    "Hauts-de-France",
    "Ile-de-France",
    "Normandie",
    "Nouvelle-Aquitaine",
    "Occitanie",
    "Pays-de-la-Loire",
    "Provence-Alpes-Cote-d'Azur",
  ],
  "French Guiana": ["Guyane"],
  "French Polynesia": [
    "Iles Australes",
    "Iles Marquises",
    "Iles Sous-le-Vent",
    "Iles Tuamotu-Gambier",
    "Iles du Vent",
  ],
  "French Southern Territories": ["French Southern Territories"],
  Gabon: [
    "Estuaire",
    "Haut-Ogooue",
    "Moyen-Ogooue",
    "Ngounie",
    "Nyanga",
    "Ogooue-Ivindo",
    "Ogooue-Lolo",
    "Ogooue-Maritime",
    "Woleu-Ntem",
  ],
  Gambia: [
    "Banjul",
    "Central River",
    "Lower River",
    "North Bank",
    "Upper River",
    "Western",
  ],
  Georgia: [
    "Abkhazia",
    "Ajaria",
    "Guria",
    "Imereti",
    "K'akheti",
    "Kvemo Kartli",
    "Mtskheta-Mtianeti",
    "Rach'a-Lechkhumi-Kvemo Svaneti",
    "Samegrelo-Zemo Svaneti",
    "Samtskhe-Javakheti",
    "Shida Kartli",
    "Tbilisi",
  ],
  Germany: [
    "Baden-Wurttemberg",
    "Bayern",
    "Berlin",
    "Brandenburg",
    "Bremen",
    "Hamburg",
    "Hessen",
    "Mecklenburg-Vorpommern",
    "Niedersachsen",
    "Nordrhein-Westfalen",
    "Rheinland-Pfalz",
    "Saarland",
    "Sachsen",
    "Sachsen-Anhalt",
    "Schleswig-Holstein",
    "Thuringen",
  ],
  Ghana: [
    "Ahafo",
    "Ashanti",
    "Bono",
    "Bono East",
    "Central",
    "Eastern",
    "Greater Accra",
    "Northern",
    "Upper East",
    "Upper West",
    "Volta",
    "Western",
  ],
  Gibraltar: ["Gibraltar"],
  Greece: [
    "Agion Oros",
    "Anatoliki Makedonia kai Thraki",
    "Attiki",
    "Dytiki Ellada",
    "Dytiki Makedonia",
    "Ionia Nisia",
    "Ipeiros",
    "Kentriki Makedonia",
    "Kriti",
    "Notio Aigaio",
    "Peloponnisos",
    "Sterea Ellada",
    "Thessalia",
    "Voreio Aigaio",
  ],
  Greenland: [
    "Avannaata Kommunia",
    "Kommune Kujalleq",
    "Kommune Qeqertalik",
    "Kommuneqarfik Sermersooq",
    "Qeqqata Kommunia",
  ],
  Grenada: [
    "Saint Andrew",
    "Saint David",
    "Saint George",
    "Saint John",
    "Saint Mark",
    "Saint Patrick",
    "Southern Grenadine Islands",
  ],
  Guadeloupe: ["Guadeloupe"],
  Guam: [
    "Agana Heights",
    "Agat",
    "Barrigada",
    "Chalan Pago-Ordot",
    "Dededo",
    "Hagatna",
    "Inarajan",
    "Mangilao",
    "Merizo",
    "Mongmong-Toto-Maite",
    "Piti",
    "Santa Rita",
    "Sinajana",
    "Talofofo",
    "Tamuning-Tumon-Harmon",
    "Yigo",
    "Yona",
  ],
  Guatemala: [
    "Alta Verapaz",
    "Baja Verapaz",
    "Chimaltenango",
    "Chiquimula",
    "El Progreso",
    "Escuintla",
    "Guatemala",
    "Huehuetenango",
    "Izabal",
    "Jalapa",
    "Jutiapa",
    "Peten",
    "Quetzaltenango",
    "Quiche",
    "Retalhuleu",
    "Sacatepequez",
    "San Marcos",
    "Santa Rosa",
    "Solola",
    "Suchitepequez",
    "Totonicapan",
    "Zacapa",
  ],
  Guernsey: ["Guernsey"],
  Guinea: [
    "Beyla",
    "Boke",
    "Conakry",
    "Coyah",
    "Dabola",
    "Dinguiraye",
    "Dubreka",
    "Fria",
    "Kankan",
    "Kouroussa",
    "Labe",
    "Mamou",
    "Siguiri",
  ],
  "Guinea-Bissau": ["Bafata", "Bissau", "Cacheu", "Gabu", "Oio"],
  Guyana: [
    "Barima-Waini",
    "Cuyuni-Mazaruni",
    "Demerara-Mahaica",
    "East Berbice-Corentyne",
    "Essequibo Islands-West Demerara",
    "Mahaica-Berbice",
    "Pomeroon-Supenaam",
    "Potaro-Siparuni",
    "Upper Demerara-Berbice",
    "Upper Takutu-Upper Essequibo",
  ],
  Haiti: [
    "Artibonite",
    "Centre",
    "Grande'Anse",
    "Nippes",
    "Nord",
    "Nord-Ouest",
    "Ouest",
    "Sud",
    "Sud-Est",
  ],
  "Heard Island and McDonald Islands": ["Heard Island and McDonald Islands"],
  "Holy See (Vatican City State)": ["Vatican City"],
  Honduras: [
    "Atlantida",
    "Choluteca",
    "Colon",
    "Comayagua",
    "Copan",
    "Cortes",
    "El Paraiso",
    "Francisco Morazan",
    "Gracias a Dios",
    "Intibuca",
    "Islas de la Bahia",
    "La Paz",
    "Lempira",
    "Ocotepeque",
    "Olancho",
    "Santa Barbara",
    "Valle",
    "Yoro",
  ],
  "Hong Kong": ["Hong Kong"],
  Hungary: [
    "Bacs-Kiskun",
    "Baranya",
    "Bekes",
    "Borsod-Abauj-Zemplen",
    "Budapest",
    "Csongrad-Csanad",
    "Fejer",
    "Gyor-Moson-Sopron",
    "Hajdu-Bihar",
    "Heves",
    "Jasz-Nagykun-Szolnok",
    "Komarom-Esztergom",
    "Nograd",
    "Pest",
    "Somogy",
    "Szabolcs-Szatmar-Bereg",
    "Tolna",
    "Vas",
    "Veszprem",
    "Zala",
  ],
  Iceland: [
    "Austurland",
    "Hofudborgarsvaedi",
    "Nordurland eystra",
    "Nordurland vestra",
    "Sudurland",
    "Sudurnes",
    "Vestfirdir",
    "Vesturland",
  ],
  India: [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ],
  Indonesia: [
    "Aceh",
    "Bali",
    "Banten",
    "Bengkulu",
    "Gorontalo",
    "Jakarta Raya",
    "Jambi",
    "Jawa Barat",
    "Jawa Tengah",
    "Jawa Timur",
    "Kalimantan Barat",
    "Kalimantan Selatan",
    "Kalimantan Tengah",
    "Kalimantan Timur",
    "Kalimantan Utara",
    "Kepulauan Bangka Belitung",
    "Kepulauan Riau",
    "Lampung",
    "Maluku",
    "Maluku Utara",
    "Nusa Tenggara Barat",
    "Nusa Tenggara Timur",
    "Papua",
    "Papua Barat",
    "Papua Barat Daya",
    "Papua Pengunungan",
    "Papua Selatan",
    "Papua Tengah",
    "Riau",
    "Sulawesi Barat",
    "Sulawesi Selatan",
    "Sulawesi Tengah",
    "Sulawesi Tenggara",
    "Sulawesi Utara",
    "Sumatera Barat",
    "Sumatera Selatan",
    "Sumatera Utara",
    "Yogyakarta",
  ],
  Iran: [
    "Alborz",
    "Ardabil",
    "Azarbayjan-e Gharbi",
    "Azarbayjan-e Sharqi",
    "Bushehr",
    "Chahar Mahal va Bakhtiari",
    "Esfahan",
    "Fars",
    "Gilan",
    "Golestan",
    "Hamadan",
    "Hormozgan",
    "Ilam",
    "Kerman",
    "Kermanshah",
    "Khorasan-e Jonubi",
    "Khorasan-e Razavi",
    "Khorasan-e Shomali",
    "Khuzestan",
    "Kohgiluyeh va Bowyer Ahmad",
    "Kordestan",
    "Lorestan",
    "Markazi",
    "Mazandaran",
    "Qazvin",
    "Qom",
    "Semnan",
    "Sistan va Baluchestan",
    "Tehran",
    "Yazd",
    "Zanjan",
  ],
  Iraq: [
    "Al Anbar",
    "Al Basrah",
    "Al Muthanna",
    "Al Qadisiyah",
    "An Najaf",
    "Arbil",
    "As Sulaymaniyah",
    "Babil",
    "Baghdad",
    "Dahuk",
    "Dhi Qar",
    "Diyala",
    "Karbala'",
    "Kirkuk",
    "Maysan",
    "Ninawa",
    "Salah ad Din",
    "Wasit",
  ],
  Ireland: [
    "Carlow",
    "Cavan",
    "Clare",
    "Cork",
    "Donegal",
    "Dublin",
    "Galway",
    "Kerry",
    "Kildare",
    "Kilkenny",
    "Laois",
    "Leitrim",
    "Limerick",
    "Longford",
    "Louth",
    "Mayo",
    "Meath",
    "Monaghan",
    "Offaly",
    "Roscommon",
    "Sligo",
    "Tipperary",
    "Waterford",
    "Westmeath",
    "Wexford",
    "Wicklow",
  ],
  "Isle of Man": ["Isle of Man"],
  Israel: [
    "HaDarom",
    "HaMerkaz",
    "HaTsafon",
    "Hefa",
    "Tel Aviv",
    "Yerushalayim",
  ],
  Italy: [
    "Abruzzo",
    "Basilicata",
    "Calabria",
    "Campania",
    "Emilia-Romagna",
    "Friuli-Venezia Giulia",
    "Lazio",
    "Liguria",
    "Lombardia",
    "Marche",
    "Molise",
    "Piemonte",
    "Puglia",
    "Sardegna",
    "Sicilia",
    "Toscana",
    "Trentino-Alto Adige",
    "Umbria",
    "Valle d'Aosta",
    "Veneto",
  ],
  Jamaica: [
    "Clarendon",
    "Hanover",
    "Kingston",
    "Manchester",
    "Portland",
    "Saint Andrew",
    "Saint Ann",
    "Saint Catherine",
    "Saint Elizabeth",
    "Saint James",
    "Saint Mary",
    "Saint Thomas",
    "Trelawny",
    "Westmoreland",
  ],
  Japan: [
    "Aichi",
    "Akita",
    "Aomori",
    "Chiba",
    "Ehime",
    "Fukui",
    "Fukuoka",
    "Fukushima",
    "Gifu",
    "Gunma",
    "Hiroshima",
    "Hokkaido",
    "Hyogo",
    "Ibaraki",
    "Ishikawa",
    "Iwate",
    "Kagawa",
    "Kagoshima",
    "Kanagawa",
    "Kochi",
    "Kumamoto",
    "Kyoto",
    "Mie",
    "Miyagi",
    "Miyazaki",
    "Nagano",
    "Nagasaki",
    "Nara",
    "Niigata",
    "Oita",
    "Okayama",
    "Okinawa",
    "Osaka",
    "Saga",
    "Saitama",
    "Shiga",
    "Shimane",
    "Shizuoka",
    "Tochigi",
    "Tokushima",
    "Tokyo",
    "Tottori",
    "Toyama",
    "Wakayama",
    "Yamagata",
    "Yamaguchi",
    "Yamanashi",
  ],
  Jersey: ["Jersey"],
  Jordan: [
    "'Ajlun",
    "Al 'Aqabah",
    "Al 'Asimah",
    "Al Balqa'",
    "Al Karak",
    "Al Mafraq",
    "At Tafilah",
    "Az Zarqa'",
    "Irbid",
    "Jarash",
    "Ma'an",
    "Madaba",
  ],
  Kazakhstan: [
    "Abay oblysy",
    "Almaty",
    "Almaty oblysy",
    "Aqmola oblysy",
    "Aqtobe oblysy",
    "Astana",
    "Atyrau oblysy",
    "Batys Qazaqstan oblysy",
    "Mangghystau oblysy",
    "Pavlodar oblysy",
    "Qaraghandy oblysy",
    "Qostanay oblysy",
    "Qyzylorda oblysy",
    "Shyghys Qazaqstan oblysy",
    "Shymkent",
    "Soltustik Qazaqstan oblysy",
    "Turkistan oblysy",
    "Ulytau oblysy",
    "Zhambyl oblysy",
    "Zhetisu oblysy",
  ],
  Kenya: [
    "Baringo",
    "Bomet",
    "Bungoma",
    "Busia",
    "Elgeyo/Marakwet",
    "Embu",
    "Garissa",
    "Homa Bay",
    "Isiolo",
    "Kajiado",
    "Kakamega",
    "Kericho",
    "Kiambu",
    "Kilifi",
    "Kirinyaga",
    "Kisii",
    "Kisumu",
    "Kitui",
    "Kwale",
    "Laikipia",
    "Lamu",
    "Machakos",
    "Makueni",
    "Mandera",
    "Marsabit",
    "Meru",
    "Migori",
    "Mombasa",
    "Murang'a",
    "Nairobi City",
    "Nakuru",
    "Nandi",
    "Narok",
    "Nyamira",
    "Nyandarua",
    "Nyeri",
    "Samburu",
    "Siaya",
    "Taita/Taveta",
    "Tana River",
    "Tharaka-Nithi",
    "Trans Nzoia",
    "Turkana",
    "Uasin Gishu",
    "Vihiga",
    "Wajir",
    "West Pokot",
  ],
  Kiribati: ["Gilbert Islands", "Line Islands"],
  Kuwait: [
    "Al 'Asimah",
    "Al Ahmadi",
    "Al Farwaniyah",
    "Al Jahra'",
    "Hawalli",
    "Mubarak al Kabir",
  ],
  Kyrgyzstan: [
    "Batken",
    "Bishkek Shaary",
    "Chuy",
    "Jalal-Abad",
    "Naryn",
    "Osh Shaary",
    "Talas",
    "Ysyk-Kol",
  ],
  Laos: [
    "Attapu",
    "Bokeo",
    "Bolikhamxai",
    "Champasak",
    "Houaphan",
    "Khammouan",
    "Louang Namtha",
    "Louangphabang",
    "Oudomxai",
    "Salavan",
    "Savannakhet",
    "Viangchan",
    "Xekong",
    "Xiangkhouang",
  ],
  Latvia: [
    "Adazu novads",
    "Aizkraukles novads",
    "Aluksnes novads",
    "Balvu novads",
    "Bauskas novads",
    "Cesu novads",
    "Daugavpils",
    "Dienvidkurzemes novads",
    "Dobeles novads",
    "Gulbenes novads",
    "Jekabpils novads",
    "Jelgava",
    "Jelgavas novads",
    "Jurmala",
    "Kekavas novads",
    "Kraslavas novads",
    "Kuldigas novads",
    "Liepaja",
    "Limbazu novads",
    "Livanu novads",
    "Ludzas novads",
    "Madonas novads",
    "Marupes novads",
    "Ogres novads",
    "Olaines novads",
    "Preilu novads",
    "Rezeknes novads",
    "Riga",
    "Ropazu novads",
    "Salaspils novads",
    "Saldus novads",
    "Saulkrastu novads",
    "Siguldas novads",
    "Smiltenes novads",
    "Talsu novads",
    "Tukuma novads",
    "Valkas novads",
    "Valmieras novads",
    "Varaklanu novads",
    "Ventspils novads",
  ],
  Lebanon: [
    "Aakkar",
    "Baalbek-Hermel",
    "Beqaa",
    "Beyrouth",
    "Liban-Nord",
    "Liban-Sud",
    "Mont-Liban",
    "Nabatiye",
  ],
  Lesotho: [
    "Berea",
    "Botha-Bothe",
    "Leribe",
    "Mafeteng",
    "Maseru",
    "Mokhotlong",
    "Qacha's Nek",
    "Quthing",
    "Thaba-Tseka",
  ],
  Liberia: [
    "Bomi",
    "Bong",
    "Grand Bassa",
    "Grand Cape Mount",
    "Grand Gedeh",
    "Margibi",
    "Montserrado",
    "Nimba",
    "River Cess",
    "River Gee",
    "Sinoe",
  ],
  Libya: [
    "Al Butnan",
    "Al Jabal al Akhdar",
    "Al Jabal al Gharbi",
    "Al Jafarah",
    "Al Jufrah",
    "Al Kufrah",
    "Al Marj",
    "Al Marqab",
    "Al Wahat",
    "An Nuqat al Khams",
    "Az Zawiyah",
    "Banghazi",
    "Darnah",
    "Misratah",
    "Murzuq",
    "Nalut",
    "Sabha",
    "Surt",
    "Tarabulus",
    "Wadi ash Shati'",
  ],
  Liechtenstein: [
    "Balzers",
    "Eschen",
    "Gamprin",
    "Mauren",
    "Planken",
    "Ruggell",
    "Schaan",
    "Triesen",
    "Triesenberg",
    "Vaduz",
  ],
  Lithuania: [
    "Alytaus apskritis",
    "Kauno apskritis",
    "Klaipedos apskritis",
    "Marijampoles apskritis",
    "Panevezio apskritis",
    "Siauliu apskritis",
    "Taurages apskritis",
    "Telsiu apskritis",
    "Utenos apskritis",
    "Vilniaus apskritis",
  ],
  Luxembourg: [
    "Capellen",
    "Clervaux",
    "Diekirch",
    "Echternach",
    "Esch-sur-Alzette",
    "Grevenmacher",
    "Luxembourg",
    "Mersch",
    "Redange",
    "Remich",
    "Vianden",
    "Wiltz",
  ],
  Macau: ["Macao"],
  Madagascar: [
    "Antananarivo",
    "Antsiranana",
    "Fianarantsoa",
    "Mahajanga",
    "Toamasina",
    "Toliara",
  ],
  Malawi: [
    "Balaka",
    "Blantyre",
    "Chikwawa",
    "Dedza",
    "Dowa",
    "Karonga",
    "Lilongwe",
    "Machinga",
    "Mangochi",
    "Mwanza",
    "Mzimba",
    "Neno",
    "Nkhotakota",
    "Ntchisi",
    "Salima",
    "Thyolo",
    "Zomba",
  ],
  Malaysia: [
    "Johor",
    "Kedah",
    "Kelantan",
    "Melaka",
    "Negeri Sembilan",
    "Pahang",
    "Perak",
    "Perlis",
    "Pulau Pinang",
    "Sabah",
    "Sarawak",
    "Selangor",
    "Terengganu",
    "Wilayah Persekutuan Kuala Lumpur",
    "Wilayah Persekutuan Labuan",
    "Wilayah Persekutuan Putrajaya",
  ],
  Maldives: [
    "Addu City",
    "Faadhippolhu",
    "Felidhu Atoll",
    "Fuvammulah",
    "Hahdhunmathi",
    "Kolhumadulu",
    "Male",
    "Mulaku Atoll",
    "North Ari Atoll",
    "North Huvadhu Atoll",
    "North Maalhosmadulu",
    "North Miladhunmadulu",
    "North Nilandhe Atoll",
    "North Thiladhunmathi",
    "South Ari Atoll",
    "South Huvadhu Atoll",
    "South Maalhosmadulu",
    "South Miladhunmadulu",
    "South Nilandhe Atoll",
    "South Thiladhunmathi",
  ],
  Mali: [
    "Bamako",
    "Gao",
    "Kayes",
    "Kidal",
    "Koulikoro",
    "Mopti",
    "Segou",
    "Sikasso",
    "Tombouctou",
  ],
  Malta: [
    "Attard",
    "Balzan",
    "Birgu",
    "Birkirkara",
    "Birzebbuga",
    "Bormla",
    "Dingli",
    "Fgura",
    "Floriana",
    "Fontana",
    "Ghajnsielem",
    "Gharb",
    "Gharghur",
    "Ghasri",
    "Ghaxaq",
    "Gudja",
    "Gzira",
    "Hamrun",
    "Iklin",
    "Isla",
    "Kalkara",
    "Kercem",
    "Kirkop",
    "Lija",
    "Luqa",
    "Marsa",
    "Marsaskala",
    "Marsaxlokk",
    "Mdina",
    "Mellieha",
    "Mgarr",
    "Mosta",
    "Mqabba",
    "Msida",
    "Mtarfa",
    "Munxar",
    "Nadur",
    "Naxxar",
    "Paola",
    "Pembroke",
    "Pieta",
    "Qala",
    "Qormi",
    "Qrendi",
    "Rabat Gozo",
    "Rabat Malta",
    "Safi",
    "Saint John",
    "Saint Julian's",
    "Saint Lucia's",
    "Saint Paul's Bay",
    "Sannat",
    "Santa Venera",
    "Siggiewi",
    "Sliema",
    "Swieqi",
    "Ta' Xbiex",
    "Tarxien",
    "Valletta",
    "Xaghra",
    "Xewkija",
    "Xghajra",
    "Zabbar",
    "Zebbug Gozo",
    "Zejtun",
    "Zurrieq",
  ],
  "Marshall Islands": ["Kwajalein", "Majuro"],
  Martinique: ["Martinique"],
  Mauritania: [
    "Adrar",
    "Assaba",
    "Brakna",
    "Dakhlet Nouadhibou",
    "Gorgol",
    "Guidimaka",
    "Inchiri",
    "Nouakchott Ouest",
    "Tagant",
    "Tiris Zemmour",
    "Trarza",
  ],
  Mauritius: [
    "Black River",
    "Flacq",
    "Grand Port",
    "Moka",
    "Pamplemousses",
    "Plaines Wilhems",
    "Port Louis",
    "Riviere du Rempart",
    "Rodrigues Islands",
    "Savanne",
  ],
  Mayotte: [
    "Bandrele",
    "Kani-Keli",
    "Koungou",
    "Mamoudzou",
    "Ouangani",
    "Pamandzi",
    "Tsingoni",
  ],
  Mexico: [
    "Aguascalientes",
    "Baja California",
    "Baja California Sur",
    "Campeche",
    "Chiapas",
    "Chihuahua",
    "Ciudad de Mexico",
    "Coahuila de Zaragoza",
    "Colima",
    "Durango",
    "Guanajuato",
    "Guerrero",
    "Hidalgo",
    "Jalisco",
    "Mexico",
    "Michoacan de Ocampo",
    "Morelos",
    "Nayarit",
    "Nuevo Leon",
    "Oaxaca",
    "Puebla",
    "Queretaro",
    "Quintana Roo",
    "San Luis Potosi",
    "Sinaloa",
    "Sonora",
    "Tabasco",
    "Tamaulipas",
    "Tlaxcala",
    "Veracruz de Ignacio de la Llave",
    "Yucatan",
    "Zacatecas",
  ],
  Micronesia: ["Chuuk", "Kosrae", "Pohnpei", "Yap"],
  Moldova: [
    "Anenii Noi",
    "Balti",
    "Basarabeasca",
    "Bender",
    "Briceni",
    "Cahul",
    "Calarasi",
    "Cantemir",
    "Causeni",
    "Chisinau",
    "Cimislia",
    "Criuleni",
    "Donduseni",
    "Drochia",
    "Dubasari",
    "Edinet",
    "Falesti",
    "Floresti",
    "Gagauzia, Unitatea teritoriala autonoma",
    "Glodeni",
    "Hincesti",
    "Ialoveni",
    "Leova",
    "Nisporeni",
    "Ocnita",
    "Orhei",
    "Rezina",
    "Riscani",
    "Singerei",
    "Soldanesti",
    "Soroca",
    "Stefan Voda",
    "Stinga Nistrului, unitatea teritoriala din",
    "Straseni",
    "Taraclia",
    "Telenesti",
    "Ungheni",
  ],
  Monaco: [
    "Fontvieille",
    "La Condamine",
    "Monaco-Ville",
    "Moneghetti",
    "Monte-Carlo",
    "Saint-Roman",
  ],
  Mongolia: [
    "Bayan-Olgiy",
    "Bulgan",
    "Darhan uul",
    "Dornod",
    "Dundgovi",
    "Dzavhan",
    "Govi-Altay",
    "Hovd",
    "Hovsgol",
    "Omnogovi",
    "Orhon",
    "Ovorhangay",
    "Selenge",
    "Tov",
    "Ulaanbaatar",
  ],
  Montenegro: [
    "Bar",
    "Berane",
    "Bijelo Polje",
    "Budva",
    "Cetinje",
    "Danilovgrad",
    "Gusinje",
    "Herceg-Novi",
    "Kolasin",
    "Kotor",
    "Mojkovac",
    "Niksic",
    "Plav",
    "Pljevlja",
    "Pluzine",
    "Podgorica",
    "Rozaje",
    "Savnik",
    "Tivat",
    "Tuzi",
    "Ulcinj",
    "Zabljak",
    "Zeta",
  ],
  Montserrat: ["Saint Anthony", "Saint Peter"],
  Morocco: [
    "Beni-Mellal-Khenifra",
    "Casablanca-Settat",
    "Draa-Tafilalet",
    "Fes- Meknes",
    "Guelmim-Oued Noun (EH-partial)",
    "L'Oriental",
    "Laayoune-Sakia El Hamra (EH-partial)",
    "Marrakech-Safi",
    "Rabat-Sale-Kenitra",
    "Souss-Massa",
    "Tanger-Tetouan-Al Hoceima",
  ],
  Mozambique: [
    "Cabo Delgado",
    "Gaza",
    "Inhambane",
    "Manica",
    "Maputo",
    "Nampula",
    "Niassa",
    "Sofala",
    "Tete",
    "Zambezia",
  ],
  Myanmar: [
    "Ayeyarwady",
    "Bago",
    "Chin",
    "Kachin",
    "Kayah",
    "Kayin",
    "Magway",
    "Mandalay",
    "Mon",
    "Nay Pyi Taw",
    "Rakhine",
    "Sagaing",
    "Shan",
    "Tanintharyi",
    "Yangon",
  ],
  Namibia: [
    "Erongo",
    "Hardap",
    "Karas",
    "Kavango East",
    "Kavango West",
    "Khomas",
    "Kunene",
    "Ohangwena",
    "Omaheke",
    "Omusati",
    "Oshana",
    "Oshikoto",
    "Otjozondjupa",
    "Zambezi",
  ],
  Nauru: ["Aiwo", "Anetan", "Yaren"],
  Nepal: [
    "Bagmati",
    "Gandaki",
    "Karnali",
    "Koshi",
    "Lumbini",
    "Madhesh",
    "Sudurpashchim",
  ],
  Netherlands: [
    "Drenthe",
    "Flevoland",
    "Fryslan",
    "Gelderland",
    "Groningen",
    "Limburg",
    "Noord-Brabant",
    "Noord-Holland",
    "Overijssel",
    "Utrecht",
    "Zeeland",
    "Zuid-Holland",
  ],
  "New Caledonia": [
    "Province Nord",
    "Province Sud",
    "Province des iles Loyaute",
  ],
  "New Zealand": [
    "Auckland",
    "Bay of Plenty",
    "Canterbury",
    "Chatham Islands Territory",
    "Gisborne",
    "Greater Wellington",
    "Hawke's Bay",
    "Manawatu-Whanganui",
    "Marlborough",
    "Nelson",
    "Northland",
    "Otago",
    "Southland",
    "Taranaki",
    "Tasman",
    "Waikato",
    "West Coast",
  ],
  Nicaragua: [
    "Boaco",
    "Carazo",
    "Chinandega",
    "Chontales",
    "Costa Caribe Norte",
    "Costa Caribe Sur",
    "Esteli",
    "Granada",
    "Jinotega",
    "Leon",
    "Madriz",
    "Managua",
    "Masaya",
    "Matagalpa",
    "Nueva Segovia",
    "Rio San Juan",
    "Rivas",
  ],
  Niger: [
    "Agadez",
    "Diffa",
    "Maradi",
    "Niamey",
    "Tahoua",
    "Tillaberi",
    "Zinder",
  ],
  Nigeria: [
    "Abia",
    "Abuja Federal Capital Territory",
    "Adamawa",
    "Akwa Ibom",
    "Anambra",
    "Bauchi",
    "Bayelsa",
    "Benue",
    "Borno",
    "Cross River",
    "Delta",
    "Ebonyi",
    "Edo",
    "Ekiti",
    "Enugu",
    "Gombe",
    "Imo",
    "Jigawa",
    "Kaduna",
    "Kano",
    "Katsina",
    "Kebbi",
    "Kogi",
    "Kwara",
    "Lagos",
    "Nasarawa",
    "Niger",
    "Ogun",
    "Ondo",
    "Osun",
    "Oyo",
    "Plateau",
    "Rivers",
    "Sokoto",
    "Taraba",
    "Yobe",
    "Zamfara",
  ],
  Niue: ["Niue"],
  "Norfolk Island": ["Norfolk Island"],
  "North Korea": ["P'yongyang"],
  "Northern Mariana Islands": ["Northern Mariana Islands"],
  Norway: [
    "Agder",
    "Innlandet",
    "More og Romsdal",
    "Nordland",
    "Oslo",
    "Rogaland",
    "Troms og Finnmark",
    "Trondelag",
    "Vestfold og Telemark",
    "Vestland",
    "Viken",
  ],
  Oman: [
    "Ad Dakhiliyah",
    "Al Buraymi",
    "Al Wusta",
    "Az Zahirah",
    "Janub al Batinah",
    "Janub ash Sharqiyah",
    "Masqat",
    "Musandam",
    "Shamal al Batinah",
    "Shamal ash Sharqiyah",
    "Zufar",
  ],
  Pakistan: [
    "Azad Jammu and Kashmir",
    "Balochistan",
    "Gilgit-Baltistan",
    "Islamabad",
    "Khyber Pakhtunkhwa",
    "Punjab",
    "Sindh",
  ],
  Palau: ["Airai", "Koror", "Melekeok", "Ngardmau", "Ngchesar", "Sonsorol"],
  Panama: [
    "Bocas del Toro",
    "Chiriqui",
    "Cocle",
    "Colon",
    "Darien",
    "Guna Yala",
    "Herrera",
    "Los Santos",
    "Ngobe-Bugle",
    "Panama",
    "Veraguas",
  ],
  "Papua New Guinea": [
    "Bougainville",
    "Central",
    "East New Britain",
    "Eastern Highlands",
    "Enga",
    "Madang",
    "Manus",
    "Milne Bay",
    "Morobe",
    "National Capital District (Port Moresby)",
    "New Ireland",
    "Northern",
    "Southern Highlands",
    "West Sepik",
    "Western",
    "Western Highlands",
  ],
  Paraguay: [
    "Alto Parana",
    "Amambay",
    "Asuncion",
    "Boqueron",
    "Caaguazu",
    "Caazapa",
    "Canindeyu",
    "Central",
    "Concepcion",
    "Cordillera",
    "Guaira",
    "Itapua",
    "Misiones",
    "Neembucu",
    "Paraguari",
    "Presidente Hayes",
    "San Pedro",
  ],
  Peru: [
    "Amazonas",
    "Ancash",
    "Apurimac",
    "Arequipa",
    "Ayacucho",
    "Cajamarca",
    "Cusco",
    "El Callao",
    "Huancavelica",
    "Huanuco",
    "Ica",
    "Junin",
    "La Libertad",
    "Lambayeque",
    "Lima",
    "Loreto",
    "Madre de Dios",
    "Moquegua",
    "Pasco",
    "Piura",
    "Puno",
    "San Martin",
    "Tacna",
    "Tumbes",
    "Ucayali",
  ],
  Philippines: [
    "Abra",
    "Agusan del Norte",
    "Agusan del Sur",
    "Aklan",
    "Albay",
    "Antique",
    "Apayao",
    "Aurora",
    "Basilan",
    "Bataan",
    "Batanes",
    "Batangas",
    "Benguet",
    "Biliran",
    "Bohol",
    "Bukidnon",
    "Bulacan",
    "Cagayan",
    "Camarines Norte",
    "Camarines Sur",
    "Camiguin",
    "Capiz",
    "Catanduanes",
    "Cavite",
    "Cebu",
    "Cotabato",
    "Davao Oriental",
    "Davao de Oro",
    "Davao del Norte",
    "Davao del Sur",
    "Dinagat Islands",
    "Eastern Samar",
    "Guimaras",
    "Ifugao",
    "Ilocos Norte",
    "Ilocos Sur",
    "Iloilo",
    "Isabela",
    "Kalinga",
    "La Union",
    "Laguna",
    "Lanao del Norte",
    "Lanao del Sur",
    "Leyte",
    "Maguindanao del Norte",
    "Maguindanao del Sur",
    "Marinduque",
    "Masbate",
    "Mindoro Occidental",
    "Mindoro Oriental",
    "Misamis Occidental",
    "Misamis Oriental",
    "Mountain Province",
    "National Capital Region",
    "Negros Occidental",
    "Negros Oriental",
    "Northern Samar",
    "Nueva Ecija",
    "Nueva Vizcaya",
    "Palawan",
    "Pampanga",
    "Pangasinan",
    "Quezon",
    "Quirino",
    "Rizal",
    "Romblon",
    "Samar",
    "Sarangani",
    "Siquijor",
    "Sorsogon",
    "South Cotabato",
    "Southern Leyte",
    "Sultan Kudarat",
    "Sulu",
    "Surigao del Norte",
    "Surigao del Sur",
    "Tarlac",
    "Tawi-Tawi",
    "Zambales",
    "Zamboanga Sibugay",
    "Zamboanga del Norte",
    "Zamboanga del Sur",
  ],
  "Pitcairn Islands": ["Pitcairn"],
  Poland: [
    "Dolnoslaskie",
    "Kujawsko-Pomorskie",
    "Lodzkie",
    "Lubelskie",
    "Lubuskie",
    "Malopolskie",
    "Mazowieckie",
    "Opolskie",
    "Podkarpackie",
    "Podlaskie",
    "Pomorskie",
    "Slaskie",
    "Swietokrzyskie",
    "Warminsko-Mazurskie",
    "Wielkopolskie",
    "Zachodniopomorskie",
  ],
  Portugal: [
    "Aveiro",
    "Beja",
    "Braga",
    "Braganca",
    "Castelo Branco",
    "Coimbra",
    "Evora",
    "Faro",
    "Guarda",
    "Leiria",
    "Lisboa",
    "Portalegre",
    "Porto",
    "Regiao Autonoma da Madeira",
    "Regiao Autonoma dos Acores",
    "Santarem",
    "Setubal",
    "Viana do Castelo",
    "Vila Real",
    "Viseu",
  ],
  "Puerto Rico": [
    "Adjuntas",
    "Aguada",
    "Aguadilla",
    "Aguas Buenas",
    "Aibonito",
    "Anasco",
    "Arecibo",
    "Arroyo",
    "Barceloneta",
    "Barranquitas",
    "Bayamon",
    "Cabo Rojo",
    "Caguas",
    "Camuy",
    "Canovanas",
    "Carolina",
    "Catano",
    "Cayey",
    "Ceiba",
    "Ciales",
    "Cidra",
    "Coamo",
    "Comerio",
    "Corozal",
    "Culebra",
    "Dorado",
    "Fajardo",
    "Florida",
    "Guanica",
    "Guayama",
    "Guayanilla",
    "Guaynabo",
    "Gurabo",
    "Hatillo",
    "Hormigueros",
    "Humacao",
    "Isabela",
    "Juana Diaz",
    "Lajas",
    "Lares",
    "Las Marias",
    "Las Piedras",
    "Loiza",
    "Luquillo",
    "Manati",
    "Maunabo",
    "Mayaguez",
    "Moca",
    "Morovis",
    "Municipio de Jayuya",
    "Municipio de Juncos",
    "Naguabo",
    "Naranjito",
    "Patillas",
    "Penuelas",
    "Ponce",
    "Quebradillas",
    "Rincon",
    "Rio Grande",
    "Sabana Grande",
    "Salinas",
    "San German",
    "San Juan",
    "San Lorenzo",
    "San Sebastian",
    "Santa Isabel Municipio",
    "Toa Alta",
    "Toa Baja",
    "Trujillo Alto",
    "Utuado",
    "Vega Alta",
    "Vega Baja",
    "Vieques",
    "Villalba",
    "Yabucoa",
    "Yauco",
  ],
  Qatar: [
    "Ad Dawhah",
    "Al Khawr wa adh Dhakhirah",
    "Al Wakrah",
    "Ar Rayyan",
    "Ash Shamal",
    "Az Za'ayin",
    "Umm Salal",
  ],
  "Republic of North Macedonia": [
    "Aracinovo",
    "Berovo",
    "Bitola",
    "Bogdanci",
    "Bogovinje",
    "Bosilovo",
    "Brvenica",
    "Butel",
    "Caska",
    "Centar",
    "Centar Zupa",
    "Cucer Sandevo",
    "Debar",
    "Delcevo",
    "Demir Hisar",
    "Demir Kapija",
    "Dojran",
    "Dolneni",
    "Gazi Baba",
    "Gevgelija",
    "Gostivar",
    "Gradsko",
    "Ilinden",
    "Jegunovce",
    "Karbinci",
    "Kavadarci",
    "Kicevo",
    "Kisela Voda",
    "Kocani",
    "Konce",
    "Kratovo",
    "Kriva Palanka",
    "Krusevo",
    "Kumanovo",
    "Lipkovo",
    "Lozovo",
    "Makedonska Kamenica",
    "Makedonski Brod",
    "Mavrovo i Rostusa",
    "Mogila",
    "Negotino",
    "Novo Selo",
    "Ohrid",
    "Petrovec",
    "Plasnica",
    "Prilep",
    "Probistip",
    "Radovis",
    "Rankovce",
    "Resen",
    "Saraj",
    "Sopiste",
    "Stip",
    "Struga",
    "Strumica",
    "Studenicani",
    "Sveti Nikole",
    "Tearce",
    "Tetovo",
    "Valandovo",
    "Vasilevo",
    "Veles",
    "Vevcani",
    "Vinica",
    "Vrapciste",
    "Zelenikovo",
    "Zelino",
    "Zrnovci",
  ],
  Romania: [
    "Alba",
    "Arad",
    "Arges",
    "Bacau",
    "Bihor",
    "Bistrita-Nasaud",
    "Botosani",
    "Braila",
    "Brasov",
    "Bucuresti",
    "Buzau",
    "Calarasi",
    "Caras-Severin",
    "Cluj",
    "Constanta",
    "Covasna",
    "Dambovita",
    "Dolj",
    "Galati",
    "Giurgiu",
    "Gorj",
    "Harghita",
    "Hunedoara",
    "Ialomita",
    "Iasi",
    "Ilfov",
    "Maramures",
    "Mehedinti",
    "Mures",
    "Neamt",
    "Olt",
    "Prahova",
    "Salaj",
    "Satu Mare",
    "Sibiu",
    "Suceava",
    "Teleorman",
    "Timis",
    "Tulcea",
    "Valcea",
    "Vaslui",
    "Vrancea",
  ],
  "Russian Federation": [
    "Adygeya, Respublika",
    "Altay, Respublika",
    "Altayskiy kray",
    "Amurskaya oblast'",
    "Arkhangel'skaya oblast'",
    "Astrakhanskaya oblast'",
    "Bashkortostan, Respublika",
    "Belgorodskaya oblast'",
    "Bryanskaya oblast'",
    "Buryatiya, Respublika",
    "Chechenskaya Respublika",
    "Chelyabinskaya oblast'",
    "Chukotskiy avtonomnyy okrug",
    "Chuvashskaya Respublika",
    "Dagestan, Respublika",
    "Ingushetiya, Respublika",
    "Irkutskaya oblast'",
    "Ivanovskaya oblast'",
    "Kabardino-Balkarskaya Respublika",
    "Kaliningradskaya oblast'",
    "Kalmykiya, Respublika",
    "Kaluzhskaya oblast'",
    "Kamchatskiy kray",
    "Karachayevo-Cherkesskaya Respublika",
    "Kareliya, Respublika",
    "Kemerovskaya oblast'",
    "Khabarovskiy kray",
    "Khakasiya, Respublika",
    "Khanty-Mansiyskiy avtonomnyy okrug",
    "Kirovskaya oblast'",
    "Komi, Respublika",
    "Kostromskaya oblast'",
    "Krasnodarskiy kray",
    "Krasnoyarskiy kray",
    "Kurganskaya oblast'",
    "Kurskaya oblast'",
    "Leningradskaya oblast'",
    "Lipetskaya oblast'",
    "Magadanskaya oblast'",
    "Mariy El, Respublika",
    "Mordoviya, Respublika",
    "Moskovskaya oblast'",
    "Moskva",
    "Murmanskaya oblast'",
    "Nenetskiy avtonomnyy okrug",
    "Nizhegorodskaya oblast'",
    "Novgorodskaya oblast'",
    "Novosibirskaya oblast'",
    "Omskaya oblast'",
    "Orenburgskaya oblast'",
    "Orlovskaya oblast'",
    "Penzenskaya oblast'",
    "Permskiy kray",
    "Primorskiy kray",
    "Pskovskaya oblast'",
    "Rostovskaya oblast'",
    "Ryazanskaya oblast'",
    "Saha, Respublika",
    "Sakhalinskaya oblast'",
    "Samarskaya oblast'",
    "Sankt-Peterburg",
    "Saratovskaya oblast'",
    "Severnaya Osetiya, Respublika",
    "Smolenskaya oblast'",
    "Stavropol'skiy kray",
    "Sverdlovskaya oblast'",
    "Tambovskaya oblast'",
    "Tatarstan, Respublika",
    "Tomskaya oblast'",
    "Tul'skaya oblast'",
    "Tverskaya oblast'",
    "Tyumenskaya oblast'",
    "Tyva, Respublika",
    "Udmurtskaya Respublika",
    "Ul'yanovskaya oblast'",
    "Vladimirskaya oblast'",
    "Volgogradskaya oblast'",
    "Vologodskaya oblast'",
    "Voronezhskaya oblast'",
    "Yamalo-Nenetskiy avtonomnyy okrug",
    "Yaroslavskaya oblast'",
    "Yevreyskaya avtonomnaya oblast'",
    "Zabaykal'skiy kray",
  ],
  Rwanda: ["Est", "Nord", "Ouest", "Sud", "Ville de Kigali"],
  Réunion: ["Reunion"],
  "Saint Barthélémy": ["Saint Barthelemy"],
  "Saint Helena, Ascension and Tristan da Cunha": ["Saint Helena"],
  "Saint Kitts and Nevis": [
    "Christ Church Nichola Town",
    "Saint Anne Sandy Point",
    "Saint George Basseterre",
    "Saint James Windward",
    "Saint John Capisterre",
    "Saint John Figtree",
    "Saint Mary Cayon",
    "Saint Paul Capisterre",
    "Saint Paul Charlestown",
    "Saint Peter Basseterre",
    "Saint Thomas Lowland",
    "Saint Thomas Middle Island",
    "Trinity Palmetto Point",
  ],
  "Saint Lucia": [
    "Anse la Raye",
    "Castries",
    "Choiseul",
    "Dennery",
    "Gros Islet",
    "Laborie",
    "Micoud",
    "Soufriere",
    "Vieux Fort",
  ],
  "Saint Martin (French part)": ["Saint Martin (French Part)"],
  "Saint Pierre and Miquelon": ["Saint Pierre and Miquelon"],
  "Saint Vincent and the Grenadines": [
    "Charlotte",
    "Grenadines",
    "Saint George",
    "Saint Patrick",
  ],
  Samoa: ["Atua", "Fa'asaleleaga", "Tuamasaga", "Vaisigano"],
  "San Marino": ["Chiesanuova", "Citta di San Marino", "Faetano", "Serravalle"],
  "Saudi Arabia": [
    "'Asir",
    "Al Bahah",
    "Al Hudud ash Shamaliyah",
    "Al Jawf",
    "Al Madinah al Munawwarah",
    "Al Qasim",
    "Ar Riyad",
    "Ash Sharqiyah",
    "Ha'il",
    "Jazan",
    "Makkah al Mukarramah",
    "Najran",
    "Tabuk",
  ],
  Senegal: [
    "Dakar",
    "Diourbel",
    "Fatick",
    "Kaffrine",
    "Kaolack",
    "Kedougou",
    "Louga",
    "Matam",
    "Saint-Louis",
    "Sedhiou",
    "Tambacounda",
    "Thies",
    "Ziguinchor",
  ],
  Serbia: [
    "Beograd",
    "Borski okrug",
    "Branicevski okrug",
    "Jablanicki okrug",
    "Juznobacki okrug",
    "Juznobanatski okrug",
    "Kolubarski okrug",
    "Kosovsko-Mitrovacki okrug",
    "Macvanski okrug",
    "Moravicki okrug",
    "Nisavski okrug",
    "Pcinjski okrug",
    "Pecki okrug",
    "Pirotski okrug",
    "Podunavski okrug",
    "Pomoravski okrug",
    "Prizrenski okrug",
    "Rasinski okrug",
    "Raski okrug",
    "Severnobacki okrug",
    "Severnobanatski okrug",
    "Srednjebanatski okrug",
    "Sremski okrug",
    "Sumadijski okrug",
    "Toplicki okrug",
    "Zajecarski okrug",
    "Zapadnobacki okrug",
    "Zlatiborski okrug",
  ],
  Seychelles: [
    "Anse Boileau",
    "Anse Royale",
    "Anse aux Pins",
    "Baie Lazare",
    "Baie Sainte Anne",
    "Beau Vallon",
    "Bel Ombre",
    "Cascade",
    "English River",
    "Grand Anse Mahe",
    "Grand Anse Praslin",
    "La Digue",
    "Pointe Larue",
    "Takamaka",
  ],
  "Sierra Leone": [
    "Eastern",
    "North Western",
    "Northern",
    "Southern",
    "Western Area",
  ],
  Singapore: ["Singapore"],
  "Sint Maarten (Dutch part)": ["Sint Maarten (Dutch Part)"],
  Slovakia: [
    "Banskobystricky kraj",
    "Bratislavsky kraj",
    "Kosicky kraj",
    "Nitriansky kraj",
    "Presovsky kraj",
    "Trenciansky kraj",
    "Trnavsky kraj",
    "Zilinsky kraj",
  ],
  Slovenia: [
    "Ajdovscina",
    "Ankaran",
    "Apace",
    "Beltinci",
    "Benedikt",
    "Bistrica ob Sotli",
    "Bled",
    "Bloke",
    "Bohinj",
    "Borovnica",
    "Bovec",
    "Braslovce",
    "Brda",
    "Brezice",
    "Brezovica",
    "Cankova",
    "Celje",
    "Cerklje na Gorenjskem",
    "Cerknica",
    "Cerkno",
    "Cirkulane",
    "Crensovci",
    "Crnomelj",
    "Destrnik",
    "Divaca",
    "Dobje",
    "Dobrepolje",
    "Dobrna",
    "Dobrova-Polhov Gradec",
    "Dobrovnik",
    "Domzale",
    "Dornava",
    "Dravograd",
    "Duplek",
    "Gorje",
    "Gornja Radgona",
    "Gornji Petrovci",
    "Grad",
    "Grosuplje",
    "Hajdina",
    "Hoce-Slivnica",
    "Hodos",
    "Horjul",
    "Hrastnik",
    "Hrpelje-Kozina",
    "Idrija",
    "Ig",
    "Ilirska Bistrica",
    "Ivancna Gorica",
    "Izola",
    "Jesenice",
    "Jursinci",
    "Kamnik",
    "Kanal",
    "Kidricevo",
    "Kobarid",
    "Kobilje",
    "Kocevje",
    "Komen",
    "Komenda",
    "Koper",
    "Kosanjevica na Krki",
    "Kostel",
    "Kranj",
    "Kranjska Gora",
    "Krizevci",
    "Krsko",
    "Kungota",
    "Kuzma",
    "Lasko",
    "Lenart",
    "Lendava",
    "Litija",
    "Ljubljana",
    "Ljutomer",
    "Log-Dragomer",
    "Logatec",
    "Loska dolina",
    "Loski Potok",
    "Lovrenc na Pohorju",
    "Luce",
    "Lukovica",
    "Majsperk",
    "Makole",
    "Maribor",
    "Markovci",
    "Medvode",
    "Menges",
    "Metlika",
    "Mezica",
    "Miklavz na Dravskem polju",
    "Miren-Kostanjevica",
    "Mirna",
    "Mirna Pec",
    "Mislinja",
    "Mokronog-Trebelno",
    "Moravce",
    "Mozirje",
    "Murska Sobota",
    "Muta",
    "Naklo",
    "Nazarje",
    "Nova Gorica",
    "Novo Mesto",
    "Odranci",
    "Oplotnica",
    "Ormoz",
    "Piran",
    "Pivka",
    "Podcetrtek",
    "Podlehnik",
    "Poljcane",
    "Polzela",
    "Postojna",
    "Prebold",
    "Preddvor",
    "Prevalje",
    "Ptuj",
    "Puconci",
    "Race-Fram",
    "Radece",
    "Radenci",
    "Radlje ob Dravi",
    "Radovljica",
    "Ravne na Koroskem",
    "Razkrizje",
    "Recica ob Savinji",
    "Rence-Vogrsko",
    "Ribnica",
    "Rogaska Slatina",
    "Rogasovci",
    "Ruse",
    "Salovci",
    "Semic",
    "Sempeter-Vrtojba",
    "Sencur",
    "Sentilj",
    "Sentjernej",
    "Sentjur",
    "Sentrupert",
    "Sevnica",
    "Sezana",
    "Skocjan",
    "Skofja Loka",
    "Skofljica",
    "Slovenj Gradec",
    "Slovenska Bistrica",
    "Slovenske Konjice",
    "Smarje pri Jelsah",
    "Smarjeske Toplice",
    "Smartno ob Paki",
    "Smartno pri Litiji",
    "Sodrazica",
    "Solcava",
    "Sostanj",
    "Starse",
    "Store",
    "Straza",
    "Sveta Trojica v Slovenskih goricah",
    "Sveti Andraz v Slovenskih Goricah",
    "Sveti Jurij ob Scavnici",
    "Sveti Jurij v Slovenskih goricah",
    "Sveti Tomaz",
    "Tabor",
    "Tisina",
    "Tolmin",
    "Trbovlje",
    "Trebnje",
    "Trnovska Vas",
    "Trzic",
    "Trzin",
    "Turnisce",
    "Velenje",
    "Velika Polana",
    "Velike Lasce",
    "Verzej",
    "Videm",
    "Vipava",
    "Vitanje",
    "Vodice",
    "Vojnik",
    "Vransko",
    "Vrhnika",
    "Vuzenica",
    "Zagorje ob Savi",
    "Zalec",
    "Zavrc",
    "Zelezniki",
    "Zetale",
    "Ziri",
    "Zrece",
    "Zuzemberk",
  ],
  "Solomon Islands": ["Guadalcanal", "Makira-Ulawa", "Malaita", "Western"],
  Somalia: [
    "Awdal",
    "Banaadir",
    "Bari",
    "Bay",
    "Galguduud",
    "Jubbada Hoose",
    "Mudug",
    "Nugaal",
    "Shabeellaha Dhexe",
    "Shabeellaha Hoose",
    "Sool",
    "Togdheer",
    "Woqooyi Galbeed",
  ],
  "South Africa": [
    "Eastern Cape",
    "Free State",
    "Gauteng",
    "Kwazulu-Natal",
    "Limpopo",
    "Mpumalanga",
    "North-West",
    "Northern Cape",
    "Western Cape",
  ],
  "South Georgia and the South Sandwich Islands": [
    "South Georgia and the South Sandwich Islands",
  ],
  "South Korea": [
    "Busan-gwangyeoksi",
    "Chungcheongbuk-do",
    "Chungcheongnam-do",
    "Daegu-gwangyeoksi",
    "Daejeon-gwangyeoksi",
    "Gangwon-teukbyeoljachido",
    "Gwangju-gwangyeoksi",
    "Gyeonggi-do",
    "Gyeongsangbuk-do",
    "Gyeongsangnam-do",
    "Incheon-gwangyeoksi",
    "Jeju-teukbyeoljachido",
    "Jeollabuk-do",
    "Jeollanam-do",
    "Sejong",
    "Seoul-teukbyeolsi",
    "Ulsan-gwangyeoksi",
  ],
  "South Sudan": [
    "Central Equatoria",
    "Eastern Equatoria",
    "Jonglei",
    "Lakes",
    "Northern Bahr el Ghazal",
    "Unity",
    "Upper Nile",
    "Warrap",
    "Western Bahr el Ghazal",
    "Western Equatoria",
  ],
  Spain: [
    "Andalucia",
    "Aragon",
    "Asturias, Principado de",
    "Canarias",
    "Cantabria",
    "Castilla y Leon",
    "Castilla-La Mancha",
    "Catalunya",
    "Ceuta",
    "Extremadura",
    "Galicia",
    "Illes Balears",
    "La Rioja",
    "Madrid, Comunidad de",
    "Melilla",
    "Murcia, Region de",
    "Navarra, Comunidad Foral de",
    "Pais Vasco",
    "Valenciana, Comunidad",
  ],
  "Sri Lanka": [
    "Central Province",
    "Eastern Province",
    "North Central Province",
    "North Western Province",
    "Northern Province",
    "Sabaragamuwa Province",
    "Southern Province",
    "Uva Province",
    "Western Province",
  ],
  "State of Palestine": [
    "Bethlehem",
    "Deir El Balah",
    "Gaza",
    "Hebron",
    "Jenin",
    "Jericho and Al Aghwar",
    "Jerusalem",
    "Khan Yunis",
    "Nablus",
    "Qalqilya",
    "Rafah",
    "Ramallah",
    "Salfit",
    "Tubas",
    "Tulkarm",
  ],
  Sudan: [
    "Blue Nile",
    "Central Darfur",
    "Gedaref",
    "Gezira",
    "Kassala",
    "Khartoum",
    "North Darfur",
    "North Kordofan",
    "Northern",
    "Red Sea",
    "River Nile",
    "Sennar",
    "South Darfur",
    "South Kordofan",
    "West Darfur",
    "West Kordofan",
    "White Nile",
  ],
  Suriname: [
    "Brokopondo",
    "Commewijne",
    "Coronie",
    "Nickerie",
    "Para",
    "Paramaribo",
    "Saramacca",
    "Sipaliwini",
    "Wanica",
  ],
  "Svalbard and Jan Mayen": ["Svalbard and Jan Mayen"],
  Swaziland: ["Hhohho", "Lubombo", "Manzini"],
  Sweden: [
    "Blekinge lan",
    "Dalarnas lan",
    "Gavleborgs lan",
    "Gotlands lan",
    "Hallands lan",
    "Jamtlands lan",
    "Jonkopings lan",
    "Kalmar lan",
    "Kronobergs lan",
    "Norrbottens lan",
    "Orebro lan",
    "Ostergotlands lan",
    "Skane lan",
    "Sodermanlands lan",
    "Stockholms lan",
    "Uppsala lan",
    "Varmlands lan",
    "Vasterbottens lan",
    "Vasternorrlands lan",
    "Vastmanlands lan",
    "Vastra Gotalands lan",
  ],
  Switzerland: [
    "Aargau",
    "Appenzell Ausserrhoden",
    "Appenzell Innerrhoden",
    "Basel-Landschaft",
    "Basel-Stadt",
    "Bern",
    "Fribourg",
    "Geneve",
    "Glarus",
    "Graubunden",
    "Jura",
    "Luzern",
    "Neuchatel",
    "Nidwalden",
    "Obwalden",
    "Sankt Gallen",
    "Schaffhausen",
    "Schwyz",
    "Solothurn",
    "Thurgau",
    "Ticino",
    "Uri",
    "Valais",
    "Vaud",
    "Zug",
    "Zurich",
  ],
  Syria: [
    "Al Hasakah",
    "Al Ladhiqiyah",
    "Al Qunaytirah",
    "Ar Raqqah",
    "As Suwayda'",
    "Dar'a",
    "Dayr az Zawr",
    "Dimashq",
    "Halab",
    "Hamah",
    "Hims",
    "Idlib",
    "Rif Dimashq",
    "Tartus",
  ],
  "São Tomé and Príncipe": ["Agua Grande", "Principe"],
  Taiwan: [
    "Changhua",
    "Chiayi",
    "Hsinchu",
    "Hualien",
    "Kaohsiung",
    "Keelung",
    "Kinmen",
    "Lienchiang",
    "Miaoli",
    "Nantou",
    "New Taipei",
    "Penghu",
    "Pingtung",
    "Taichung",
    "Tainan",
    "Taipei",
    "Taitung",
    "Taoyuan",
    "Yilan",
    "Yunlin",
  ],
  Tajikistan: [
    "Dushanbe",
    "Khatlon",
    "Kuhistoni Badakhshon",
    "Nohiyahoi Tobei Jumhuri",
    "Sughd",
  ],
  Tanzania: [
    "Arusha",
    "Dar es Salaam",
    "Dodoma",
    "Geita",
    "Iringa",
    "Kagera",
    "Kaskazini Pemba",
    "Kaskazini Unguja",
    "Katavi",
    "Kigoma",
    "Kilimanjaro",
    "Kusini Pemba",
    "Kusini Unguja",
    "Lindi",
    "Manyara",
    "Mara",
    "Mbeya",
    "Mjini Magharibi",
    "Morogoro",
    "Mtwara",
    "Mwanza",
    "Njombe",
    "Pwani",
    "Rukwa",
    "Ruvuma",
    "Shinyanga",
    "Simiyu",
    "Singida",
    "Songwe",
    "Tabora",
    "Tanga",
  ],
  Thailand: [
    "Amnat Charoen",
    "Ang Thong",
    "Bueng Kan",
    "Buri Ram",
    "Chachoengsao",
    "Chai Nat",
    "Chaiyaphum",
    "Chanthaburi",
    "Chiang Mai",
    "Chiang Rai",
    "Chon Buri",
    "Chumphon",
    "Kalasin",
    "Kamphaeng Phet",
    "Kanchanaburi",
    "Khon Kaen",
    "Krabi",
    "Krung Thep Maha Nakhon",
    "Lampang",
    "Lamphun",
    "Loei",
    "Lop Buri",
    "Mae Hong Son",
    "Maha Sarakham",
    "Mukdahan",
    "Nakhon Nayok",
    "Nakhon Pathom",
    "Nakhon Phanom",
    "Nakhon Ratchasima",
    "Nakhon Sawan",
    "Nakhon Si Thammarat",
    "Nan",
    "Narathiwat",
    "Nong Bua Lam Phu",
    "Nong Khai",
    "Nonthaburi",
    "Pathum Thani",
    "Pattani",
    "Phangnga",
    "Phatthalung",
    "Phayao",
    "Phetchabun",
    "Phetchaburi",
    "Phichit",
    "Phitsanulok",
    "Phra Nakhon Si Ayutthaya",
    "Phrae",
    "Phuket",
    "Prachin Buri",
    "Prachuap Khiri Khan",
    "Ranong",
    "Ratchaburi",
    "Rayong",
    "Roi Et",
    "Sa Kaeo",
    "Sakon Nakhon",
    "Samut Prakan",
    "Samut Sakhon",
    "Samut Songkhram",
    "Saraburi",
    "Satun",
    "Si Sa Ket",
    "Sing Buri",
    "Songkhla",
    "Sukhothai",
    "Suphan Buri",
    "Surat Thani",
    "Surin",
    "Tak",
    "Trang",
    "Trat",
    "Ubon Ratchathani",
    "Udon Thani",
    "Uthai Thani",
    "Uttaradit",
    "Yala",
    "Yasothon",
  ],
  "Timor-Leste": [
    "Aileu",
    "Ainaro",
    "Baucau",
    "Cova Lima",
    "Dili",
    "Ermera",
    "Lautem",
    "Liquica",
    "Oecussi",
    "Viqueque",
  ],
  Togo: ["Centrale", "Kara", "Maritime", "Plateaux", "Savanes"],
  Tokelau: ["Tokelau"],
  Tonga: ["'Eua", "Ha'apai", "Niuas", "Tongatapu", "Vava'u"],
  "Trinidad and Tobago": [
    "Arima",
    "Chaguanas",
    "Couva-Tabaquite-Talparo",
    "Diego Martin",
    "Mayaro-Rio Claro",
    "Penal-Debe",
    "Point Fortin",
    "Port of Spain",
    "Princes Town",
    "San Fernando",
    "San Juan-Laventille",
    "Sangre Grande",
    "Siparia",
    "Tobago",
    "Tunapuna-Piarco",
  ],
  Tunisia: [
    "Beja",
    "Ben Arous",
    "Bizerte",
    "Gabes",
    "Gafsa",
    "Jendouba",
    "Kairouan",
    "Kasserine",
    "Kebili",
    "L'Ariana",
    "La Manouba",
    "Le Kef",
    "Mahdia",
    "Medenine",
    "Monastir",
    "Nabeul",
    "Sfax",
    "Sidi Bouzid",
    "Siliana",
    "Sousse",
    "Tataouine",
    "Tozeur",
    "Tunis",
    "Zaghouan",
  ],
  Turkey: [
    "Adana",
    "Adiyaman",
    "Afyonkarahisar",
    "Agri",
    "Aksaray",
    "Amasya",
    "Ankara",
    "Antalya",
    "Ardahan",
    "Artvin",
    "Aydin",
    "Balikesir",
    "Bartin",
    "Batman",
    "Bayburt",
    "Bilecik",
    "Bingol",
    "Bitlis",
    "Bolu",
    "Burdur",
    "Bursa",
    "Canakkale",
    "Cankiri",
    "Corum",
    "Denizli",
    "Diyarbakir",
    "Duzce",
    "Edirne",
    "Elazig",
    "Erzincan",
    "Erzurum",
    "Eskisehir",
    "Gaziantep",
    "Giresun",
    "Gumushane",
    "Hakkari",
    "Hatay",
    "Igdir",
    "Isparta",
    "Istanbul",
    "Izmir",
    "Kahramanmaras",
    "Karabuk",
    "Karaman",
    "Kars",
    "Kastamonu",
    "Kayseri",
    "Kilis",
    "Kirikkale",
    "Kirklareli",
    "Kirsehir",
    "Kocaeli",
    "Konya",
    "Kutahya",
    "Malatya",
    "Manisa",
    "Mardin",
    "Mersin",
    "Mugla",
    "Mus",
    "Nevsehir",
    "Nigde",
    "Ordu",
    "Osmaniye",
    "Rize",
    "Sakarya",
    "Samsun",
    "Sanliurfa",
    "Siirt",
    "Sinop",
    "Sirnak",
    "Sivas",
    "Tekirdag",
    "Tokat",
    "Trabzon",
    "Tunceli",
    "Usak",
    "Van",
    "Yalova",
    "Yozgat",
    "Zonguldak",
  ],
  Turkmenistan: ["Ahal", "Balkan", "Dasoguz", "Lebap", "Mary"],
  "Turks and Caicos Islands": ["Turks and Caicos Islands"],
  Tuvalu: ["Funafuti"],
  "USA Minor Outlying Islands": ["Palmyra Atoll"],
  Uganda: [
    "Abim",
    "Adjumani",
    "Agago",
    "Alebtong",
    "Apac",
    "Arua",
    "Bududa",
    "Bugiri",
    "Buhweju",
    "Buikwe",
    "Bukedea",
    "Bukomansibi",
    "Bukwo",
    "Bulambuli",
    "Buliisa",
    "Bundibugyo",
    "Bushenyi",
    "Busia",
    "Buvuma",
    "Buyende",
    "Gomba",
    "Gulu",
    "Hoima",
    "Ibanda",
    "Iganga",
    "Isingiro",
    "Jinja",
    "Kaabong",
    "Kabale",
    "Kabarole",
    "Kaberamaido",
    "Kalangala",
    "Kaliro",
    "Kalungu",
    "Kampala",
    "Kamuli",
    "Kamwenge",
    "Kanungu",
    "Kapchorwa",
    "Kasese",
    "Katakwi",
    "Kayunga",
    "Kibaale",
    "Kiboga",
    "Kibuku",
    "Kiruhura",
    "Kiryandongo",
    "Kisoro",
    "Kitgum",
    "Koboko",
    "Kole",
    "Kotido",
    "Kumi",
    "Kween",
    "Kyankwanzi",
    "Kyegegwa",
    "Kyenjojo",
    "Lamwo",
    "Lira",
    "Luuka",
    "Luwero",
    "Lwengo",
    "Lyantonde",
    "Manafwa",
    "Maracha",
    "Masaka",
    "Masindi",
    "Mayuge",
    "Mbale",
    "Mbarara",
    "Mitooma",
    "Mityana",
    "Moroto",
    "Moyo",
    "Mpigi",
    "Mubende",
    "Mukono",
    "Nakapiripirit",
    "Nakaseke",
    "Nakasongola",
    "Namayingo",
    "Napak",
    "Nebbi",
    "Ntoroko",
    "Ntungamo",
    "Nwoya",
    "Oyam",
    "Pader",
    "Rakai",
    "Rubirizi",
    "Rukungiri",
    "Sembabule",
    "Sheema",
    "Sironko",
    "Soroti",
    "Tororo",
    "Wakiso",
    "Yumbe",
    "Zombo",
  ],
  Ukraine: [
    "Avtonomna Respublika Krym",
    "Cherkaska oblast",
    "Chernihivska oblast",
    "Chernivetska oblast",
    "Dnipropetrovska oblast",
    "Donetska oblast",
    "Ivano-Frankivska oblast",
    "Kharkivska oblast",
    "Khersonska oblast",
    "Khmelnytska oblast",
    "Kirovohradska oblast",
    "Kyiv",
    "Kyivska oblast",
    "Luhanska oblast",
    "Lvivska oblast",
    "Mykolaivska oblast",
    "Odeska oblast",
    "Poltavska oblast",
    "Rivnenska oblast",
    "Sevastopol",
    "Sumska oblast",
    "Ternopilska oblast",
    "Vinnytska oblast",
    "Volynska oblast",
    "Zakarpatska oblast",
    "Zaporizka oblast",
    "Zhytomyrska oblast",
  ],
  "United Arab Emirates": [
    "'Ajman",
    "Abu Zaby",
    "Al Fujayrah",
    "Ash Shariqah",
    "Dubayy",
    "Ra's al Khaymah",
    "Umm al Qaywayn",
  ],
  "United Kingdom": ["England", "Northern Ireland", "Scotland", "Wales"],
  "United States": [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District of Columbia",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ],
  Uruguay: [
    "Artigas",
    "Canelones",
    "Cerro Largo",
    "Colonia",
    "Durazno",
    "Flores",
    "Florida",
    "Lavalleja",
    "Maldonado",
    "Montevideo",
    "Paysandu",
    "Rio Negro",
    "Rivera",
    "Rocha",
    "Salto",
    "San Jose",
    "Soriano",
    "Tacuarembo",
    "Treinta y Tres",
  ],
  Uzbekistan: [
    "Andijon",
    "Buxoro",
    "Farg'ona",
    "Jizzax",
    "Namangan",
    "Navoiy",
    "Qashqadaryo",
    "Qoraqalpog'iston Respublikasi",
    "Samarqand",
    "Sirdaryo",
    "Surxondaryo",
    "Toshkent",
    "Xorazm",
  ],
  Vanuatu: ["Malampa", "Sanma", "Shefa", "Tafea"],
  Venezuela: [
    "Amazonas",
    "Anzoategui",
    "Apure",
    "Aragua",
    "Barinas",
    "Bolivar",
    "Carabobo",
    "Cojedes",
    "Delta Amacuro",
    "Dependencias Federales",
    "Distrito Capital",
    "Falcon",
    "Guarico",
    "La Guaira",
    "Lara",
    "Merida",
    "Miranda",
    "Monagas",
    "Nueva Esparta",
    "Portuguesa",
    "Sucre",
    "Tachira",
    "Trujillo",
    "Yaracuy",
    "Zulia",
  ],
  Vietnam: [
    "An Giang",
    "Ba Ria - Vung Tau",
    "Bac Giang",
    "Bac Kan",
    "Bac Lieu",
    "Bac Ninh",
    "Ben Tre",
    "Binh Dinh",
    "Binh Duong",
    "Binh Phuoc",
    "Binh Thuan",
    "Ca Mau",
    "Can Tho",
    "Cao Bang",
    "Da Nang",
    "Dak Lak",
    "Dak Nong",
    "Dien Bien",
    "Dong Nai",
    "Dong Thap",
    "Gia Lai",
    "Ha Giang",
    "Ha Nam",
    "Ha Noi",
    "Ha Tinh",
    "Hai Duong",
    "Hai Phong",
    "Hau Giang",
    "Ho Chi Minh",
    "Hoa Binh",
    "Hung Yen",
    "Khanh Hoa",
    "Kien Giang",
    "Kon Tum",
    "Lai Chau",
    "Lam Dong",
    "Lang Son",
    "Lao Cai",
    "Long An",
    "Nam Dinh",
    "Nghe An",
    "Ninh Binh",
    "Ninh Thuan",
    "Phu Tho",
    "Phu Yen",
    "Quang Binh",
    "Quang Nam",
    "Quang Ngai",
    "Quang Ninh",
    "Quang Tri",
    "Soc Trang",
    "Son La",
    "Tay Ninh",
    "Thai Binh",
    "Thai Nguyen",
    "Thanh Hoa",
    "Thua Thien-Hue",
    "Tien Giang",
    "Tra Vinh",
    "Tuyen Quang",
    "Vinh Long",
    "Vinh Phuc",
    "Yen Bai",
  ],
  "Virgin Islands (British)": ["Virgin Islands, British"],
  "Virgin Islands (USA)": ["Virgin Islands, U.S."],
  "Wallis and Futuna": ["Sigave", "Uvea"],
  "Western Sahara": ["Western Sahara"],
  Yemen: [
    "'Adan",
    "'Amran",
    "Abyan",
    "Ad Dali'",
    "Al Bayda'",
    "Al Hudaydah",
    "Al Jawf",
    "Al Mahwit",
    "Amanat al 'Asimah",
    "Dhamar",
    "Hadramawt",
    "Hajjah",
    "Ibb",
    "Lahij",
    "Ma'rib",
    "Sa'dah",
    "San'a'",
    "Shabwah",
    "Ta'izz",
  ],
  Zambia: [
    "Central",
    "Copperbelt",
    "Eastern",
    "Luapula",
    "Lusaka",
    "Muchinga",
    "North-Western",
    "Northern",
    "Southern",
    "Western",
  ],
  Zimbabwe: [
    "Bulawayo",
    "Harare",
    "Manicaland",
    "Mashonaland Central",
    "Mashonaland East",
    "Mashonaland West",
    "Masvingo",
    "Matabeleland North",
    "Matabeleland South",
    "Midlands",
  ],
  "Åland Islands": [
    "Eckeroe",
    "Finstroem",
    "Hammarland",
    "Jomala",
    "Lemland",
    "Mariehamn",
    "Saltvik",
  ],
};

export default CountryStateData;
